// Add your custom JS here.

/*---------------------------------------------------------------------------

[Table Of Contents]

1. Stepper form

2. dropzone (upload file)

3. job processing

---------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------
1. Stepper form
---------------------------------------------------------------------------*/
if (0 < $('#job-stepper').length) {
    var element = document.querySelector("#job-stepper");
    // Initialize Stepper
    var stepper = new KTStepper(element);

    // Handle next step for stepper form
    switch( $('#job-stepper-form').data('job-type') ) {
        case 'update':
            stepper.on("kt.stepper.next", function (stepper) {
                switch(stepper.currentStepIndex) {
                    case 1:
                        stepper.goNext(); // go next step
                        break;
                    case 2:
                        if ($('#tt-select-service').val()) {
                            stepper.goNext(); // go next step
                            $('#tt-select-service').removeClass('bg-danger-subtle');
                            $('#tt-job-summary-service').html($('#tt-select-service option:selected').text());
                        } else {
                            $('#tt-select-service').addClass('bg-danger-subtle');
                        }
                        break;
                    case 3:
                        if ($('#tt-select-pool').val()) {
                            stepper.goNext(); // go next step
                            $('#tt-select-pool').removeClass('bg-danger-subtle');
                            $('#tt-job-summary-pool').html($('#tt-select-pool').val());
                        } else {
                            $('#tt-select-pool').addClass('bg-danger-subtle');
                        }
                        break;
                }

            });
            break;
        case 'reset':
            stepper.on("kt.stepper.next", function (stepper) {
                switch(stepper.currentStepIndex) {
                    case 1:
                        if ($('#tt-select-pool').val()) {
                            stepper.goNext(); // go next step
                            $('#tt-select-pool').removeClass('bg-danger-subtle');
                            $('#tt-job-summary-pool').html($('#tt-select-pool').val());
                        } else {
                            $('#tt-select-pool').addClass('bg-danger-subtle');
                        }
                        break;
                }
            });
            break;
    }

    // Handle previous step
    stepper.on("kt.stepper.previous", function (stepper) {
        stepper.goPrevious(); // go previous step
    });
}


/*---------------------------------------------------------------------------
2. dropzone (upload file)
---------------------------------------------------------------------------*/
// get upload url
if (0 < $('#job-stepper-form').length && 'update' == $('#job-stepper-form').data('job-type')) {
    var uploadUrl = $('#job-stepper-form').data('upload-url');

    var myDropzone = new Dropzone("#tt-dropzone-file", {
        url: uploadUrl, // Set the url for your upload script location
        paramName: "tt_filename", // The name that will be used to transfer the file
        maxFiles: 1,
        maxFilesize: 32, // MB
        addRemoveLinks: true,
        acceptedFiles: ".xls,.xlsx,.csv", // Extensions de fichier acceptées
        accept: function(file, done) {
            done();
        }
    });

    myDropzone.on('complete', file => {
        if('success' == file.status) {
            $('#data-kt-stepper-action-next').removeClass('disabled');
            $('#tt-filename').val(file.upload.filename);
            $('#tt-job-summary-filename').html(file.upload.filename);
            $('.dz-complete .dz-details').addClass('bg-success bg-opacity-25');
            $('.dz-complete .dz-details').css('z-index', 10);
        } else {
            // if error
        }
    });
}


/*---------------------------------------------------------------------------
3. job processing
---------------------------------------------------------------------------*/
$('#start-process').on('click', function() {
    var progressBar = $('#tt-job-progressbar .progress-bar');

    // disable button to avoid user interaction
    $(this).addClass('disabled');
    $(this).children('.indicator-label').css('display', 'none');
    $(this).children('.indicator-progress').css('display', 'block');

    $('#data-kt-stepper-action-back').addClass('disabled');

    // get form data
    var formData = $('#job-stepper-form').serialize(),
        url = $('#start-process').data('url');

    // ajax request
    $.ajax({
        url: url,
        method: 'GET',
        data: formData += '&action=tt_job_processing&tt_job_type=' + $('#job-stepper-form').data('job-type'),
        dataType:'json',
        beforeSend: function() {
            // display progress bar
            $('#job-processing').slideDown();

            // update progress
            setTimeout(function() {
                progressBar.css('width', '25%').attr('aria-valuenow', '25');
                progressBar.text('25%');
            }, 1000);
        },
        success: function(xhr) {
            // update button
            $('#start-process .indicator-progress').css('display', 'none');
            $('#start-process .indicator-done').css('display', 'flex');

            $('#job-result').css('display', 'block');

            // job terminated successfully
            if ('SUCCESS' == xhr.status) {
                // update progress
                progressBar.css('width', '50%').attr('aria-valuenow', '50');
                progressBar.text('50%');

                // recursive function that checks for result via an ajax request
                waiting_for_result(url, xhr.job_id);
            } else { // job terminated with error
                switch (xhr.reason) {
                    case '500':
                        $('#job-result .alert').text('Erreur de communication avec le serveur, veuillez réessayer plus tard.');
                        break;
                    case 'timeout':
                        $('#job-result .alert').text('Délai de réponse serveur dépassé.');
                        break;
                    default:
                        $('#job-result .alert').text('Une erreur est survenue, merci de réessayer.');
                        break;
                }

                progressBar.addClass('bg-danger');
                $('#job-result .alert').css('display', 'block');
            }
        },
        error: function(xhr, status, error) {
            $('#job-result').css('display', 'block');
            $('#job-result .alert').text('Une erreur est survenue, merci de réessayer.');
        },
        complete: function() {
        }
    });
});

/**
 * recursive function that launches an ajax request
 * to check if the result from the async API call has been received.
 * If not, function waits 5 second before relaunching a request
 *
 * @param STRING url
 * @param INT job_id
 */
function waiting_for_result(url, job_id)
{
    var progressBar = $('#tt-job-progressbar .progress-bar');

    $.ajax({
        url: url,
        method: 'GET',
        data: 'action=tt_job_waiting_for_result&job_id=' + job_id,
        dataType:'json',
        beforeSend: function() {
        },
        success: function(xhr) {
            // job terminated successfully
            if ('SUCCESS' == xhr.status) {
                // update progress
                progressBar.css('width', '100%').attr('aria-valuenow', '100');
                progressBar.text('100%');

                // display result
                $('#job-result .card').css('display', 'block');
                $('#job-result .card-text #booking').html(xhr.log_details.nb_reservation);
                $('#job-result .card-text #tag-updated').html(xhr.log_details.nb_tag_updated);
            } else { // result not updated, try again
                setTimeout(function() {
                    waiting_for_result(url, job_id)
                }, 5000);
            }
        },
        error: function(xhr, status, error) {
            $('#job-result').css('display', 'block');
            $('#job-result .alert').text('Une erreur est survenue, merci de réessayer.');
        },
        complete: function() {
            // Masquer la barre de progression lorsque le traitement est terminé
            $('#progress-bar').hide();
        }
    });
}